// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"053853a5","211":"50f1e821","423":"c8c072d5","462":"0f32c201","787":"c03fb080","880":"6c7da96b"}[chunkId] + ".chunk.js";
};